import * as React from 'react'
import { connect } from 'react-redux'

import { Button, TYPES } from './../components/shared/button'
import RecordingData from './../components/recordings/recordingData'
import RecordingsFilter from './../components/recordings/recordingsFilter'
import Page from './../components/shared/page'
import Modal from './../components/shared/modal'
import { fetchVisits, fetchMoreVisits, updateParams } from  './../redux/actions/visits'
import { hideWalkthroughModal } from "./../redux/actions/auth"

import './../styles/recordings/recordings.css'


class Recordings extends React.Component {
  constructor (props) {
     super(props)

     this.state = {
       showModal: this.props.auth.showWalkthroughModal
     };
   }

  componentDidMount() {
    this.props.fetchVisits()
  }

  hideModal = () => {
    this.setState({showModal: false})
    this.props.hideWalkthroughModal()
  }

  loadMore = () => {
    this.props.fetchMoreVisits()
  }

  render () {
    const { showModal } = this.state
    return (
      <Page history={this.props.history} >
        <div className='recordings-header'>
          <p>RECORDINGS</p>
        </div>
        <div className='recordings-content'>
          <RecordingsFilter />
          <RecordingData visits={this.props.visits.visits} />
          {this.props.visits.loadMore &&
            <div className='load-button'>
                <Button
                  text='Load More'
                  type='logIn'
                  onClick={() => this.loadMore()}
                  buttonType={TYPES.DEFAULT}
                />
            </div>
          }
        </div>
        <footer></footer>

        {showModal &&
          <Modal onCloseRequest={() => this.hideModal()}>
          <div className='intro-video'>
            <div className='intro-title'>
              <h1>Product Walkthrough</h1>
            </div>
            <iframe
              title='Product Tour'
              src='https://www.youtube.com/embed/g1d8A9yPM6E'
              height='85%'
              width='85%'
              frameBorder='0'>
            </iframe>
          </div>
          </Modal>}
      </Page>
    )
  }
}

const mapStateToProps = (state) => {
  return state
}

const mapDispatchToProps = dispatch => {
  return {
    fetchVisits: () => {
      return dispatch(fetchVisits());
    },
    fetchMoreVisits: () => {
      return dispatch(fetchMoreVisits());
    },
    updateParams: (params) => {
      return dispatch(updateParams(params));
    },
    hideWalkthroughModal: () => {
      return dispatch(hideWalkthroughModal());
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Recordings)



// WEBPACK FOOTER //
// ./src/pages/recordings.js